import { Link } from 'react-router-dom';
import { postListFetcher } from '@/shared/api/list';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';

interface InsuranceRequest extends ListRow {
  id: number;
  fio?: string;
  phone?: string;
  email?: string;
  create_time?: number;
  referrer?: string;
  user_id?: number | null;
  status_name?: string;
  manager_name?: string | null;
  user_files?: unknown[];
}

const STATUS_OPTIONS = [
  { value: '1', label: 'Новый' },
  { value: '2', label: 'В работе' },
  { value: '3', label: 'Отмененный' },
  { value: '4', label: 'Выполнен' },
];

const config: ListPageConfig<InsuranceRequest> = {
  queryKey: 'insurance-requests',
  title: 'Страхование',
  errorText: 'Ошибка загрузки заявок на страхование',
  fetchList: postListFetcher('/insurance/request/get-list/'),
  rows: ['data'],
  baseParams: { sort: '-id' },
  // Legacy loads nothing until at least one filter is set.
  requireFilter: true,
  filters: [
    { name: 'id', label: 'Поиск по id', kind: 'text', placeholder: 'Поиск по id...' },
    { name: 'referrer', label: 'Источник', kind: 'text', placeholder: 'Источник...' },
    {
      name: 'status_ids',
      label: 'Фильтр по статусам',
      kind: 'multiselect',
      options: STATUS_OPTIONS,
    },
    { name: 'create_time_from', label: 'От', kind: 'datetime' },
    { name: 'create_time_to', label: 'До', kind: 'datetime' },
  ],
  columns: [
    { header: '#', render: (_, { number }) => number },
    { header: 'ФИО', render: (item) => item.fio },
    {
      header: 'ID заявки',
      render: (item) => <Link to={`/insurance/insurance/cart/${item.id}`}>{item.id}</Link>,
    },
    { header: 'Дата и время', render: (item) => formatUnixDateTime(item.create_time) },
    {
      header: 'Прикрепленные документы',
      render: (item) => (item.user_files?.length ? `Файлов: ${item.user_files.length}` : 'Нет'),
    },
    {
      header: 'Контакты',
      render: (item) => (
        <>
          <div>{item.phone}</div>
          <div>{item.email}</div>
        </>
      ),
    },
    { header: 'Пользователь Uremont', render: (item) => (item.user_id ? 'Да' : 'Нет') },
    { header: 'Источник', render: (item) => item.referrer },
    { header: 'Статус', render: (item) => item.status_name },
    { header: 'Ответственный', render: (item) => item.manager_name || 'Нет' },
  ],
};

export const InsurancePage = () => <GenericListPage config={config} />;
